import { axiosClient } from "services/axios";

export const CLIENTS_PAGE_SIZE = 200;

export function getClients({
  clientgroupid,
  page = 1,
  pageSize = CLIENTS_PAGE_SIZE,
  search,
}: {
  clientgroupid?: string | null;
  page?: number;
  pageSize?: number;
  search?: string;
} = {}) {
  return axiosClient
    .get("users/clients", {
      params: {
        clientgroupid: clientgroupid ?? undefined,
        page,
        pageSize,
        ...(search !== undefined && search !== "" && { search }),
      },
    })
    .then((res) => res.data);
}

export function deleteClient(clientid: string | number) {
  return axiosClient.post("users/delete-client", {
    clientid: Number(clientid),
  });
}
